import { CdkDragDrop, CdkDragEnd, CdkDragEnter, CdkDragExit, CdkDragStart, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { DialogData } from 'app/reports/reportdialog';
import { Subject, zip } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-patient-bed-transfer',
  templateUrl: './patient-bed-transfer.component.html',
  styleUrls: ['./patient-bed-transfer.component.scss']
})
export class PatientBedTransferComponent implements OnInit {
  destroybed$: Subject<boolean> = new Subject<boolean>();
  private rowheight = '110';
  private rowWidth = '180';
  private totalCount: any;
  private totalOccupied: any;
  private totalAvailable: any;
  private roomCategoryList: any = [];
  private showspinner: boolean = false;
  private newroomId: any;
  private prevroomId: string;
  private ipdId: string;
  private prevData: any;
  private contdata: any;
  private widthvalue: number;
  private heightvalue: number;
  private imagename: any;
  private url: string;
  constructor(private dialogRef: MatDialogRef<PatientBedTransferComponent>, private authService: AuthService,
    private dashboardService: DashboardService,
    @Inject(MAT_DIALOG_DATA) private data: DialogData, private dialog: MatDialog, private ipdServices: IPDService) { }

  ngOnInit(): void {
    this.totalCount = 0;
    this.totalOccupied = 0;
    this.totalAvailable = 0;
    this.roomCategoryList = [];
    this.getMasterList();
    this.tableHeight(this.rowheight);
    this.tablewidth(this.rowWidth);
  }
  ngOnDestroy(): void {
    this.destroybed$.next(true);
    this.destroybed$.unsubscribe();
    this.totalCount = null;
    this.totalOccupied = null;
    this.totalAvailable = null;
    this.roomCategoryList = null;
    this.imagename = null;
    this.url = null;
    this.contdata = null;
    this.prevData = null;
    this.ipdId = null;
    this.prevroomId = null;
    this.newroomId = null;
  }
  getMasterList() {
    this.showspinner = true;
    zip(this.ipdServices.getRoomCategoryCount(), this.ipdServices.getAdmittedPateints()).pipe(takeUntil(this.destroybed$)).subscribe(([result1, result2]) => {
    
      this.roomCategoryList = result1.map(obj => {
        let x = result2.filter(obj2 => obj2.fK_RoomCategoryId == obj.pK_RoomCategoryId);
        return { ...obj, 'rooms': x, 'availableRooms': Array(obj.roomAvailable) }
      });

      result2.forEach(element => {
        let imgRegId = element.fK_RegId;
        if (imgRegId != 0) {
          this.getPatientPic(imgRegId);
        }
      });
      this.totalOccupied = result1.reduce((total, item) => total + item.roomOccupied, 0);
      this.totalAvailable = result1.reduce((total, item) => total + item.roomAvailable, 0);
      this.totalCount = this.totalAvailable + this.totalOccupied;
    });
    if (this.roomCategoryList.length == 0) {
      this.showspinner = false;
    }
  }

  closedialog() {
    this.dialog.closeAll();
  }

  tablewidth(value) {
    this.rowWidth = value + 'px';
    this.widthvalue = parseInt(this.rowWidth)
  }
  tableHeight(value) {
    this.rowheight = value + 'px';
    this.heightvalue = parseInt(this.rowheight)
  }

  drop(event: CdkDragDrop<string[]>, id: any) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      this.prevData = event.previousContainer.data;
      this.contdata = event.container.data;
      this.prevroomId = this.prevData.pK_RoomId;
      this.ipdId = this.prevData.pK_IPDId;
      this.newroomId = this.contdata.pK_RoomId;
    }
    this.patBedtransfer();
  }

  patBedtransfer() {
    let payload = {
      "RegDetailDto": [
        {
          "FK_IPDID": this.ipdId,
          "FK_BedID": this.prevroomId,
          "NewBedId": this.newroomId,
          "FK_CreatedById": this.authService.Loggeduser.userid,
          "FK_BillingBedID": 2,
          "PK_TranId": 0,
          "IsEdit": 0
        }
      ]
    }
    this.ipdServices.ipdRegDetails(payload).pipe(takeUntil(this.destroybed$)).subscribe(data => {
      if (data.statusCode == 1) {
        this.getMasterList();
      }
    });
  }

  getPatientPic(value) {
    this.dashboardService.getoldphoto(value).pipe(takeUntil(this.destroybed$)).subscribe(data => {
      if (data.length > 0) {
        let getImage = data.message;
        this.url = data[0]?.documentURL + "?" + Math.floor(Math.random() * 100) + 1;
        this.imagename = data[0]?.fk_RegId;

      }
      this.showspinner = false;
    },
      err => {
        this.showspinner = false;
      });
  }
}
